module.exports = __webpack_public_path__ + "static/media/placeholder.8b7c92e8.svg";